import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { observer } from 'mobx-react';
import { TextSkeleton } from '@udemy-v2/react-reveal-components';
import { useClpPurchaseContext } from '../../context/clp-purchase-context.react-component';
import { CourseSidebarNoTabsContainer } from './course-sidebar-no-tabs-container.react-component';
import { CourseSidebarCollapsibleActionsContainer } from './course-sidebar-collapsible-actions-container.react-component';
import { CourseSidebarTabsContainer } from './course-sidebar-tabs-container.react-component';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
import styles from './course-sidebar-container.module.scss';
export const SIDEBAR_PREVIEW_UI_REGION = 'sidebar.introductionAsset';
export const CourseSidebarContainerSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.container}><TextSkeleton className={styles.skeleton} withTitle={true} lineCountPerParagraph={3} paragraphCount={4} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface CourseSidebarContentProps {
  placement: CourseContentPlacement;
  personalContent: React.ReactNode;
  teamsContent: React.ReactNode;
  renderTabContainer: boolean;
  useCollapsiblePurchaseSection?: boolean;
}

/**
 * CourseSidebarContent - handles the reactive loading/content logic
 * This component is wrapped with observer to react to MobX changes
 */
const CourseSidebarContentInternal = t0 => {
  const $ = _c(8);
  const {
    placement,
    personalContent,
    teamsContent,
    renderTabContainer,
    useCollapsiblePurchaseSection
  } = t0;
  const {
    isLoading
  } = useClpPurchaseContext();
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CourseSidebarContainerSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (renderTabContainer) {
    let t1;
    if ($[1] !== personalContent || $[2] !== placement || $[3] !== teamsContent) {
      t1 = <CourseSidebarTabsContainer personalContent={personalContent} teamsContent={teamsContent} placement={placement} />;
      $[1] = personalContent;
      $[2] = placement;
      $[3] = teamsContent;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (useCollapsiblePurchaseSection) {
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CourseSidebarCollapsibleActionsContainer />;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t1;
  if ($[6] !== placement) {
    t1 = <CourseSidebarNoTabsContainer placement={placement} />;
    $[6] = placement;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
const CourseSidebarContent = observer(CourseSidebarContentInternal);
interface CourseSidebarContainerProps {
  placement: CourseContentPlacement;
  personalContent: React.ReactNode;
  teamsContent: React.ReactNode;
  renderTabContainer: boolean;
  useCollapsiblePurchaseSection?: boolean;
}

/**
 * CourseSidebarContainer - wraps sidebar purchase content
 * CoursePreviewEntryPoint is now rendered at the parent level to avoid re-renders
 * from design system's useViewport hooks in SidebarPopout/SidebarNormalFlow
 */
export function CourseSidebarContainer(t0) {
  const $ = _c(6);
  const {
    placement,
    personalContent,
    teamsContent,
    renderTabContainer,
    useCollapsiblePurchaseSection
  } = t0;
  let t1;
  if ($[0] !== personalContent || $[1] !== placement || $[2] !== renderTabContainer || $[3] !== teamsContent || $[4] !== useCollapsiblePurchaseSection) {
    t1 = <CourseSidebarContent placement={placement} personalContent={personalContent} teamsContent={teamsContent} renderTabContainer={renderTabContainer} useCollapsiblePurchaseSection={useCollapsiblePurchaseSection} />;
    $[0] = personalContent;
    $[1] = placement;
    $[2] = renderTabContainer;
    $[3] = teamsContent;
    $[4] = useCollapsiblePurchaseSection;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}